import { isAppLang } from './getEnv';

const isArabic = isAppLang('ar');

export const mapApiPlatformToAdapted = (platform) => {
  const apiPlatformToAdaptedPlatform = {
    news: 'news',
    instagram_post: 'instagram',
    instagram_comment: 'instagramComment',
    twitter_post: 'twitter',
    telegram_channel_post: 'telegram',
    newspaper_news: 'newspaper',
    eitaa_channel_post: 'eitaa',
    bale_channel_post: 'bale',
    rubika_channel_post: 'rubika',
    soroush_post: 'soroush',
    eitaa_channel: 'eitaa',
    bale_channel: 'bale',
    rubika_channel: 'rubika',
    linkedin_post: 'linkedin',
    virasty: 'virasty',
    virasty_post: 'virasty',
    virasty_user: 'virasty',
  };
  return apiPlatformToAdaptedPlatform[platform];
};

export const platformToReducerName = {
  news: 'newsContentReducer',
  'news-copy': 'copyNewsContentReducer',
  instagram: 'instagramContentReducer',
  instagramComment: 'instagramCommentByCommentContentReducer',
  instagramCommentByPost: 'instagramCommentByPostContentReducer',
  twitter: 'twitterContentReducer',
  virasty: 'virastyContentReducer',
  telegram: 'telegramContentReducer',
  linkedin: 'linkedinContentReducer',
  newspaper: 'newspaperContentReducer',
  multiPlatform: 'multiPlatformContentReducer',
  nativePlatforms: 'nativePlatformsContentReducer',
};

export const mapPlatformToPath = (platform) => {
  const platformToApiPath = {
    news: 'newsagencies',
    instagram: 'instagramusers',
    twitter: 'twitterusers',
    virasty: 'virastyusers',
    telegram: 'telegramchannels',
    newspaper: 'newspaperagencies',
    nativePlatforms: 'iranian-platforms-channels',
    linkedin: 'linkedinusers',
  };
  return platformToApiPath[platform];
};

export const mapToApiPlatform = {
  multiPlatform: 'multi-platform',
  news: 'news',
  instagram: 'instagram',
  instagramComment: 'instagramcomments',
  instagramCommentByPost: 'instagramcomments',
  instagramStories: 'instagramstories',
  twitter: 'twitter',
  telegram: 'telegram',
  linkedin: 'linkedin',
  newspaper: 'newspaper',
  kiosk: 'kiosk',
  nativePlatforms: 'iranian-platforms',
  eitaa: 'iranian-platforms',
  bale: 'iranian-platforms',
  rubika: 'iranian-platforms',
  virasty: 'virasty',
  telegramGroups: 'telegramgroups',
  cafeBazaar: 'cafebazaar',
};

export const mapToFrontPlatform = {
  'multi-platform': 'multiPlatform',
  news: 'news',
  instagram: 'instagram',
  instagramcomments: 'instagramComment',
  instagramstories: 'instagramStories',
  twitter: 'twitter',
  telegram: 'telegram',
  linkedin: 'linkedin',
  newspaper: 'newspaper',
  kiosk: 'kiosk',
  'iranian-platforms': 'nativePlatforms',
  bale_channel_post: 'bale',
  rubika_channel_post: 'rubika',
  eitaa_channel_post: 'eitaa',
  virasty: 'virasty',
  telegramgroups: 'telegramGroups',
  cafebazaarcomments: 'cafeBazaar',
};

export const reducerNameToPlatform = {
  newsContentReducer: 'news',
  copyNewsContentReducer: 'news-copy',
  instagramContentReducer: 'instagram',
  twitterContentReducer: 'twitter',
  virastyContentReducer: 'virasty',
  telegramContentReducer: 'telegram',
  instagramCommentByCommentContentReducer: 'instagramComment',
  instagramCommentByPostContentReducer: 'instagramCommentByPost',
  newspaperContentReducer: 'newspaper',
  nativePlatformsContentReducer: 'nativePlatforms',
};

export const mapFeatureToPlatforms = {
  contents: isArabic
    ? ['multiPlatform', 'news', 'instagram', 'twitter', 'telegram']
    : [
        'multiPlatform',
        'news',
        'instagram',
        'instagramComment',
        'twitter',
        'virasty',
        'telegram',
        'linkedin',
        'newspaper',
        'nativePlatforms',
      ],
  statistics: isArabic
    ? ['news', 'instagram', 'twitter', 'telegram']
    : [
        'news',
        'instagram',
        'instagramComment',
        'twitter',
        'virasty',
        'telegram',
        'linkedin',
        'nativePlatforms',
      ],
  resources: isArabic
    ? ['news', 'instagram', 'twitter', 'telegram']
    : [
        'news',
        'instagram',
        'twitter',
        'virasty',
        'telegram',
        'linkedin',
        'newspaper',
        'nativePlatforms',
      ],
  blacklist: isArabic
    ? ['news', 'instagram', 'twitter', 'telegram']
    : [
        'news',
        'instagram',
        'twitter',
        'virasty',
        'telegram',
        'linkedin',
        'newspaper',
        'nativePlatforms',
      ],
  bulletins: isArabic
    ? ['news', 'instagram', 'twitter', 'telegram']
    : [
        'news',
        'instagram',
        'instagramStories',
        'instagramComment',
        'twitter',
        'telegram',
        'newspaper',
        'virasty',
        'kiosk',
        'nativePlatforms',
        'linkedin',
      ],
  summary: [
    'news',
    'instagram',
    'twitter',
    'telegram',
    'newspaper',
    'nativePlatforms',
    'virasty',
  ],
  sentiment: [
    'news',
    'nativePlatforms',
    'eitaa',
    'bale',
    'rubika',
    'telegram',
    'twitter',
    'linkedin',
    'instagram',
    'instagramComment',
  ],
  comparisons: ['news', 'instagram', 'twitter', 'telegram'],
  dashboard: ['instagram', 'twitter', 'telegram'],
  alarms: [
    'news',
    'instagram',
    'twitter',
    'telegram',
    'linkedin',
    'newspaper',
    'bale',
    'rubika',
    'eitaa',
    'virasty',
    'cafeBazaar',
  ],
  brandBaan: [
    'multiPlatform',
    'news',
    'instagram',
    'instagramComment',
    'twitter',
    'telegram',
    'linkedin',
    // 'newspaper',
    'bale',
    'rubika',
    'eitaa',
    'virasty',
  ],
  stream: isArabic
    ? ['news', 'instagram', 'twitter', 'telegram']
    : [
        'news',
        'instagram',
        'twitter',
        'virasty',
        'telegram',
        'newspaper',
        'nativePlatforms',
      ],
  streamWithHashtags: ['instagram', 'twitter', 'virasty', 'telegram'],
  vipResources: ['instagram', 'twitter', 'telegram'],
};

export const apiPathToPlatform = {
  '/multi-platform/posts': 'multiPlatform',
  '/news/posts': 'news',
  '/instagram/posts': 'instagram',
  '/twitter/posts': 'twitter',
  '/virasty/posts': 'virasty',
  '/telegram/posts': 'telegram',
  '/linkedin/posts': 'linkedin',
  '/newspaper/posts': 'newspaper',
  '/iranian-platforms/posts': 'nativePlatforms',
};

export const mapPlatform = {
  multiPlatform: {
    color: '#199DA3',
    icon: 'ri-function-line',
    apiPath: '/multi-platform/posts',
  },
  news: {
    usernamePrefix: '',
    color: '#199DA3',
    icon: 'ri-global-line',
    avatarSize: {
      width: 65,
      height: 36,
    },
    apiPath: '/news/posts',
  },
  instagram: {
    usernamePrefix: '@',
    color: '#C63C73',
    icon: 'ri-instagram-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/instagram/posts',
  },
  instagramComment: {
    usernamePrefix: '@',
    color: '#9CAEBB',
    icon: 'ri-discuss-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/instagram/comments',
  },
  instagramStories: {
    usernamePrefix: '@',
    color: '#C63C73',
    icon: 'ri-smartphone-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/instagram/stories',
  },
  twitter: {
    usernamePrefix: '@',
    color: '#5AD1F6',
    icon: 'ri-twitter-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/twitter/posts',
  },
  virasty: {
    usernamePrefix: '@',
    color: '#3b96d2',
    icon: 'virasty-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/virasty/posts',
  },
  telegram: {
    usernamePrefix: '@',
    color: '#32AADD',
    icon: 'ri-telegram-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/telegram/posts',
  },
  linkedin: {
    usernamePrefix: '@',
    color: '#0a66c2',
    icon: 'ri-linkedin-box-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/linkedin/posts',
  },
  newspaper: {
    usernamePrefix: '',
    color: '#199DA3',
    icon: 'ri-newspaper-line',
    avatarSize: {
      width: 65,
      height: 36,
    },
    apiPath: '/newspaper/posts',
  },
  kiosk: {
    usernamePrefix: '',
    color: '#0F7173',
    icon: 'ri-newspaper-line',
    avatarSize: {
      width: 65,
      height: 36,
    },
    apiPath: '/newspaper/kiosk',
  },
  nativePlatforms: {
    usernamePrefix: '@',
    color: '#199DA3',
    icon: 'ri-message-3-line',
    avatarSize: {
      width: 36,
      height: 36,
    },
    apiPath: '/iranian-platforms/posts',
  },
};
